import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from '@material-ui/core';
import {hideModal} from 'Core/ducks/modal';
import {Empty, isLoaded} from 'Core/models/Async';
import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import Modal from 'Shared/components/Modal';
import {changeSSOUrl} from 'Users/ducks/SSO/ssoAccount';
import {SSOEntityId} from 'Users/models/SSOEntityId';

type SSOConfirmationModalProps = {
  message: number;
};

const SSOConfirmationModal = ({message}: SSOConfirmationModalProps) => {
  const dispatch = useDispatch();

  const {ssoUrl} = useSelector((state: ReducerState) => state.user.sso.account);

  useEffect(() => {
    return () => {
      dispatch(changeSSOUrl(new Empty()));
    };
  }, [dispatch]);

  return (
    <Modal title="Accessing External Website" open onClose={() => dispatch(hideModal())}>
      <DialogContent>
        <Grid container direction="column" alignItems="center">
          {ssoUrl && isLoaded(ssoUrl) ? (
            <>
              <DialogContentText>
                {message && (message == SSOEntityId.EMW || message == SSOEntityId.EasyBill) && (
                  <Typography>Click the button below to access the external website.</Typography>
                )}
              </DialogContentText>
              <Button
                color="primary"
                onClick={() => {
                  window.open(ssoUrl.Data.url!);
                  dispatch(hideModal());
                }}
              >
                Open link in new tab
              </Button>
            </>
          ) : (
            <CircularProgress color="primary" />
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => dispatch(hideModal())}>Cancel</Button>
      </DialogActions>
    </Modal>
  );
};

export default SSOConfirmationModal;
